// Polish translations (default language)
export default {
  common: {
    loading: "Ładowanie...",
    error: "Błąd",
    cancel: "Anuluj",
    confirm: "Potwierdź",
    save: "Zapisz",
    close: "Zamknij",
    yes: "Tak",
    no: "Nie",
    submit: "Wyślij",
    clear: "Wyczyść",
    refresh: "Odśwież",
    back: "Wróć",
    next: "Dalej",
    previous: "Poprzedni",
    search: "Szukaj",
    filter: "Filtruj",
    sort: "Sortuj",
    actions: "Akcje",
    status: "Status",
    details: "Szczegóły",
    noData: "Brak danych",
    connectionLost: "Połączenie utracone. Próba ponownego połączenia..."
  },

  login: {
    title: "ZAKODOWANE MIASTA",
    subtitle: "Zaloguj swój zespół",
    teamName: "Nazwa zespołu",
    password: "Hasło",
    passwordOptional: "",
    teamNamePlaceholder: "Wpisz nazwę zespołu",
    passwordPlaceholder: "Wpisz hasło",
    joinGame: "Dołącz do gry",
    joiningGame: "Dołączanie...",
    readyToExplore: "Gotowi na grę? START!",
    startAdventure: "",
    adminAccess: "Dostęp administratora"
  },

  adminLogin: {
    title: "Panel Administratora",
    subtitle: "Zaloguj się, aby zarządzać grą",
    username: "Nazwa użytkownika",
    password: "Hasło",
    usernamePlaceholder: "Wpisz nazwę użytkownika",
    passwordPlaceholder: "Wpisz hasło",
    login: "Zaloguj się",
    loggingIn: "Logowanie...",
    backToGame: "Powrót do gry"
  },

  dashboard: {
    title: "Panel zespołu",
    yourTeamIs: "Wasza nazwa to:",
    howToPlay: "Jak grać?",
    welcome: "Witaj",
    totalPoints: "Punkty",
    completed: "Ukończone",
    position: "Pozycja",
    gameActive: "Gra aktywna",
    gameFinished: "Gra zakończona",
    gameNotStarted: "Gra nie rozpoczęta",
    waitingForStart: "Oczekiwanie na rozpoczęcie gry...",
    congratulations: "Gratulacje!",
    gameCompleted: "Ukończyłeś grę!",
    finalScore: "Wynik końcowy",
    tabs: {
      game: "Gra",
      ranking: "Ranking",
      stats: "Statystyki",
      teams: "Zespoły",
      chat: "Czat"
    },
    stopGame: {
      title: "Zakończ grę wcześniej?",
      message: "Czy na pewno chcesz zakończyć grę? Ta akcja jest nieodwracalna.",
      confirm: "Tak, zakończ grę",
      cancel: "Anuluj"
    },
    logout: "Wyloguj się",
    // New keys for completion section
    allPuzzlesSolved: "Wszystkie zagadki rozwiązane!",
    writeDigits: "Spisz cyfry z kafelków i oblicz kod zatrzymania używając karty z formułą.",
    stopClock: "ZATRZYMAJ CZAS!",
    yourTime: "Wasz czas",
    waitForAnnouncement: "Poczekajcie na ogłoszenie wyników przez organizatora. Dziękujemy za udział w grze!",
    youCompletedGame: "ukończyliście grę!"
  },

  gameProgress: {
    title: "Postęp w grze",
    challenges: "Wyzwania",
    challengesCompleted: "Ukończone wyzwania",
    pointsEarned: "Zdobyte punkty",
    attemptsUsed: "Wykorzystane próby",
    currentChallenge: "Aktualne wyzwanie",
    nextChallenge: "Następne wyzwanie",
    noMoreChallenges: "Brak więcej wyzwań",
    status: {
      correct: "Poprawna",
      incorrect: "Niepoprawna",
      submitted: "Oczekuje",
      notAttempted: "Nie podjęto"
    },
    tile: "Kafelek",
    points: "pkt",
    attempts: "próby",
    // New keys
    yourProgress: "Twój postęp",
    gameCompleted: "Ukończyliście grę!",
    congratsWaitResults: "Gratulacje! Poczekajcie na wyniki.",
    gameNotStartedYet: "Gra jeszcze się nie rozpoczęła",
    waitForOperator: "Poczekaj na start od organizatora",
    gameEnded: "Gra zakończona",
    thankYou: "Dziękujemy za udział!",
    gamePaused: "Gra wstrzymana",
    waitForResume: "Poczekaj na wznowienie",
    gameInactive: "Gra nieaktywna",
    tilesUnlocked: "Kafelki zostaną odblokowane po starcie gry",
    // Tile labels
    questionLabel: "Pytanie",
    digitForCode: "Cyfra do kodu",
    tapToOpen: "Dotknij",
    noPuzzles: "Brak pytań",
    waitForGameStart: "Poczekaj na rozpoczęcie gry"
  },

  // New section for tile modal
  tileModal: {
    questionNumber: "Pytanie nr",
    enterAnswer: "Wpisz odpowiedź i sprawdź",
    answerPlaceholder: "Wpisz odpowiedź...",
    correct: "Brawo!",
    incorrect: "Niestety...",
    wrongAnswer: "Nieprawidłowa odpowiedź. Spróbuj ponownie!",
    connectionError: "Błąd połączenia. Spróbuj ponownie.",
    digitForCode: "Cyfra do kodu",
    checking: "Sprawdzam...",
    checkAnswer: "Sprawdź odpowiedź"
  },

  answerForm: {
    title: "Wyślij odpowiedź",
    tileNumber: "Numer kafelka",
    tileNumberPlaceholder: "Wpisz numer kafelka",
    yourAnswer: "Twoja odpowiedź",
    answerPlaceholder: "Wpisz swoją odpowiedź...",
    submit: "Wyślij odpowiedź",
    submitting: "Wysyłanie...",
    clear: "Wyczyść",
    hint: "Upewnij się, że numer kafelka jest poprawny przed wysłaniem.",
    successMessage: "Odpowiedź wysłana pomyślnie!",
    errorMessage: "Nie udało się wysłać odpowiedzi. Spróbuj ponownie."
  },

  ranking: {
    title: "Ranking",
    position: "Poz.",
    team: "Zespół",
    points: "Punkty",
    completed: "Ukończone",
    lastActivity: "Ostatnia aktywność",
    yourTeam: "Twój zespół",
    noTeams: "Brak zespołów w rankingu",
    medals: {
      gold: "Złoto",
      silver: "Srebro",
      bronze: "Brąz"
    },
    status: {
      active: "Aktywny",
      inactive: "Nieaktywny",
      finished: "Zakończył"
    }
  },

  timer: {
    timeRemaining: "Pozostały czas",
    timeAlmostUp: "Czas prawie się skończył!",
    timeRunningLow: "Mało czasu",
    gameEnded: "Gra zakończona",
    hours: "godz.",
    minutes: "min.",
    seconds: "sek."
  },

  stats: {
    title: "Statystyki gry",
    totalTeams: "Liczba zespołów",
    activeTeams: "Aktywne zespoły",
    totalAnswers: "Wysłane odpowiedzi",
    correctAnswers: "Poprawne odpowiedzi",
    averageScore: "Średni wynik",
    topScore: "Najlepszy wynik",
    completionRate: "Wskaźnik ukończenia",
    averageTime: "Średni czas",
    totalPoints: "Punkty",
    solved: "Rozwiązane",
    position: "Pozycja",
    attempts: "Próby",
    progressSummary: "Podsumowanie postępu",
    collectedDigits: "Zebrane cyfry",
    allSolved: "Wszystkie pytania rozwiązane!",
    checkStopCode: "Sprawdź kod zatrzymania",
    noData: "Brak danych",
    waitingForGame: "Poczekaj na rozpoczęcie gry"
  },

  admin: {
    title: "Panel zarządzania grą",
    games: "Gry",
    teams: "Zespoły",
    selectGame: "Wybierz grę",
    noGames: "Brak dostępnych gier",
    gameStatus: {
      draft: "Szkic",
      ready: "Gotowa",
      active: "Aktywna",
      paused: "Wstrzymana",
      finished: "Zakończona"
    },
    actions: {
      startGame: "Rozpocznij grę",
      pauseGame: "Wstrzymaj grę",
      resumeGame: "Wznów grę",
      endGame: "Zakończ grę",
      refreshData: "Odśwież dane"
    },
    confirmStart: "Czy na pewno chcesz rozpocząć grę?",
    confirmEnd: "Czy na pewno chcesz zakończyć grę? Ta akcja jest nieodwracalna.",
    gameStarted: "Gra została rozpoczęta",
    gameEnded: "Gra została zakończona",
    logout: "Wyloguj się"
  },

  validation: {
    teamNameRequired: "Nazwa zespołu jest wymagana",
    teamNameMinLength: "Nazwa zespołu musi mieć co najmniej 2 znaki",
    teamNameMaxLength: "Nazwa zespołu może mieć maksymalnie 50 znaków",
    passwordMinLength: "Hasło musi mieć co najmniej 4 znaki",
    passwordRequired: "Hasło jest wymagane",
    tileNumberRequired: "Numer kafelka jest wymagany",
    tileNumberInvalid: "Nieprawidłowy numer kafelka",
    answerRequired: "Odpowiedź jest wymagana",
    answerMaxLength: "Odpowiedź może mieć maksymalnie 500 znaków",
    usernameRequired: "Nazwa użytkownika jest wymagana"
  },

  errors: {
    loginFailed: "Logowanie nie powiodło się. Sprawdź dane logowania.",
    networkError: "Brak połączenia z internetem",
    serverError: "Błąd serwera. Spróbuj ponownie później.",
    sessionExpired: "Sesja wygasła. Zaloguj się ponownie.",
    sessionInvalidated: "Twoja sesja została zakończona - zalogowano się z innego urządzenia.",
    unknownError: "Wystąpił nieznany błąd.",
    gameNotFound: "Gra nie została znaleziona.",
    teamNotFound: "Zespół nie został znaleziony.",
    alreadySubmitted: "Odpowiedź została już wysłana dla tego kafelka.",
    gameNotActive: "Gra nie jest aktywna."
  },

  offline: {
    checkConnection: "Sprawdź połączenie i spróbuj ponownie"
  },

  notifications: {
    answerCorrect: "Brawo! Poprawna odpowiedź!",
    answerIncorrect: "Niestety, niepoprawna odpowiedź. Spróbuj ponownie.",
    pointsEarned: "Zdobyto {points} punktów!",
    newChallenge: "Nowe wyzwanie dostępne!",
    gameStarted: "Gra rozpoczęta! Powodzenia!",
    gameEnded: "Gra zakończona. Sprawdź swój wynik.",
    connectionRestored: "Połączenie przywrócone."
  },

  completion: {
    congratulations: "Gratulacje!",
    youCompleted: "ukończyłeś grę",
    stopCode: "Kod zatrzymania",
    showToOperator: "Pokaż ten kod operatorowi gry",
    points: "Punkty",
    ranking: "Ranking",
    firstPlace: "Pierwsze miejsce! 🏆",
    secondPlace: "Drugie miejsce! 🥈",
    thirdPlace: "Trzecie miejsce! 🥉",
    place: "miejsce",
    awesome: "Super!"
  },

  stopCode: {
    enterCode: "Wpisz kod zatrzymania",
    allSolvedHint: "Rozwiązaliście wszystkie zagadki! Oblicz kod i zatrzymaj zegar.",
    calculateHint: "Użyj karty z formułą, aby obliczyć {{digits}}-cyfrowy kod z zebranych cyfr",
    stopClock: "Zatrzymaj zegar",
    checking: "Sprawdzam...",
    wrongCode: "Nieprawidłowy kod. Sprawdź obliczenia i spróbuj ponownie.",
    connectionError: "Błąd połączenia. Spróbuj ponownie.",
    congratulations: "GRATULACJE!",
    clockStopped: "zatrzymaliście zegar!",
    yourTime: "Wasz czas",
    waitForResults: "Poczekajcie na ogłoszenie wyników przez operatora",
    closeHint: "Zamknij i wróć do gry"
  },

  teamsProgress: {
    title: "Postęp zespołów",
    solvedCount: "rozwiązanych",
    yourTeam: "Twój zespół",
    noTeams: "Brak innych zespołów",
    // New keys
    congratulations: "Gratulacje!",
    youFinished: "Ukończyliście grę!",
    resultsAtFinish: "Wyniki poznacie na mecie!",
    rankingHidden: "Ranking jest teraz dla Was ukryty. Poczekajcie na ogłoszenie wyników przez organizatora.",
    rankingFrozen: "Ranking zamrożony!",
    rankingFrozenDesc: "Na {{minutes}} minut przed końcem gry ranking jest zamrożony. Dajcie z siebie wszystko!",
    otherTeams: "inne zespoły",
    nextRefreshIn: "Kolejne odświeżenie za",
    dataRefreshedEvery: "Dane odświeżane co {{minutes}} minut",
    rankingFrozenUntilEnd: "Ranking zamrożony do końca gry",
    teamPhotoAlt: "Zdjęcie zespołu {{name}}",
    tapToClose: "Dotknij aby zamknąć"
  },

  movementDiagram: {
    title: "Diagram ruchu",
    efficiency: "Efektywność trasy",
    time: "Czas",
    optimalRoute: "Trasa optymalna",
    teamRoute: "Trasa zespołu",
    solvedCount: "Rozwiązano {{solved}} z {{total}} punktów",
    showDiagram: "Pokaż diagram ruchu",
    noOptimalRoute: "Brak zdefiniowanej trasy optymalnej"
  },

  phoneVerification: {
    title: "Podaj numer telefonu",
    subtitle: "Numer telefonu jest wymagany do komunikacji w trakcie gry.",
    country: "Kraj",
    phoneNumber: "Numer telefonu",
    phonePlaceholder: "123 456 789",
    phoneHint: "Format: {{dial}} {{mask}}",
    phoneHintGeneric: "Wpisz numer bez prefiksu kraju ({{dial}})",
    submit: "Zapisz i kontynuuj",
    submitting: "Zapisywanie...",
    errorInvalidFormat: "Nieprawidłowy numer telefonu. Sprawdź wybrany kraj i wpisany numer.",
    privacyNote: "Twój numer będzie używany wyłącznie do komunikacji w trakcie gry.",
    success: "Numer telefonu został zapisany"
  },

  // New section for game ended modal
  gameEnded: {
    end: "KONIEC!",
    timeUp: "Czas gry dobiegł końca.",
    goToFinish: "Jak najszybciej kierujcie się na metę!",
    moreInfoSms: "Więcej informacji w SMS.",
    gameFinished: "Gra zakończona"
  },

  // New section for team photo upload
  teamPhoto: {
    header: "TAK WIDZĄ WASZ ZESPÓŁ:",
    visibleInRanking: "Inne zespoły zobaczą to zdjęcie w rankingu",
    noPhoto: "Brak zdjęcia - dodajcie swoje!",
    photoAlt: "Zdjęcie Waszego zespołu",
    uploading: "Przesyłanie...",
    changePhoto: "Zmień zdjęcie",
    addPhoto: "Dodaj zdjęcie zespołu",
    cameraOrGallery: "Możesz zrobić zdjęcie aparatem lub wybrać z galerii",
    invalidFormat: "Niedozwolony format pliku. Użyj JPG, PNG, GIF lub WebP.",
    tooLarge: "Zdjęcie jest za duże. Maksymalny rozmiar to 5MB.",
    saved: "Zdjęcie zostało zapisane!",
    uploadError: "Wystąpił błąd podczas przesyłania zdjęcia"
  },

  // Chat with organizer
  chat: {
    title: "Czat z organizatorem",
    tabTitle: "Czat",
    noMessages: "Brak wiadomości",
    startConversation: "Rozpocznij rozmowę z organizatorem",
    typeMessage: "Napisz wiadomość...",
    send: "Wyślij",
    sending: "Wysyłanie...",
    attachImage: "Dołącz zdjęcie",
    newMessage: "Nowa wiadomość",
    operator: "Organizator",
    you: "Ty",
    today: "Dzisiaj",
    yesterday: "Wczoraj",
    imageUploading: "Wysyłanie zdjęcia...",
    messageSent: "Wysłano",
    messageError: "Błąd wysyłania",
    connectionError: "Błąd połączenia. Spróbuj ponownie.",
    loadError: "Nie udało się załadować wiadomości",
    emptyMessage: "Wiadomość nie może być pusta",
    imageTooLarge: "Zdjęcie jest za duże. Maksymalny rozmiar to 5MB.",
    invalidImageFormat: "Niedozwolony format. Użyj JPG, PNG, GIF lub WebP.",
    compressingImage: "Kompresowanie zdjęcia...",
    clickToEnlarge: "Kliknij aby powiększyć",
    closeImage: "Zamknij",
    tapToOpen: "Dotknij aby otworzyć czat"
  }
} as const;

export type TranslationKeys = typeof import('./pl').default;
